// extracted by mini-css-extract-plugin
export var boxesContainer = "our-approach-module--boxes-container--47wjB";
export var paragraph = "our-approach-module--paragraph--OOpL8";
export var singleBoxDescription = "our-approach-module--single-box-description--OL1CG";